RivalIQ.apps.SocialPosts.module('widgets', function (widgets, App, Backbone, Marionette, $, _) {

    'use strict';

    const ObservationView = Marionette.ItemView.mixin({

        ui: {
            infoBubbles: '.fa-info-circle',
            detailsLink: '.observation-details-link'
        },

        events: {
            'click @ui.detailsLink': 'onDetailsLinkClick'
        },

        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },

        template: '#linksSharedObservationTemplate',

        serializeData: function () {

            const me = this;
            const data = me.model.toJSON();

            data.name = _.get(RivalIQ.enums.linksSharedObservationTypes, [data.observationType, 'name'], data.observationType);
            data.description = _.get(RivalIQ.enums.linksSharedObservationTypes, [data.observationType, 'description'], null);

            const link = _.get(RivalIQ.enums.linksSharedObservationTypes, [data.observationType, 'link'], null);
            data.link = null;
            if (link) {
                let props;

                if (_.isFunction(link.propsFcn)) {
                    props = link.propsFcn(data);
                } else {
                    props = link.props;
                }

                props = _.pick(_.defaults({}, props, me.getProps()), RivalIQ.apps.SocialPosts.utils.validWidgetOptions);
                data.link = {
                    html: link.html,
                    href: RivalIQ.apps.Dashboard.router.router.resolveCurationRoute(me.dashboardModel.curation.id, props)
                };
            }

            const company = RivalIQ.state.landscape.getCompanyById(data.companyId);
            data.presence_icon_url = company.getIcon();
            data.companyAbbr = RivalIQ.utils.companyDisplay.getAbbreviation(company.attributes);

            return data;
        },

        onBeforeShow: function () {
            const me = this;
            me.ui.infoBubbles.popover();
        },

        onDetailsLinkClick: function () {
            const me = this;
            RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.PostedURLsClickedObservationDetails, {
                type: me.model.get('observationType')
            });
        }
    });

    const EmptyView = Marionette.ItemView.extend({
        className: 'x-empty',
        template: '#linksSharedObservationEmptyTemplate'
    });


    const ObservationColumn = Marionette.CollectionView.mixin({
        childView: ObservationView,
        className: 'col-md-6',

        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },

        childViewOptions: function () {

            const me = this;

            return {
                dashboardModel: me.dashboardModel
            };
        }
    });

    const LinksSharedObservationsView = RivalIQ.views.CollectionView.mixin({
        childView: ObservationColumn,
        emptyView: EmptyView,
        className: 'list-group row insights-observations',

        dashboardModelEvents: {
            'change': 'reload'
        },

        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },

        loadData: function () {
            const me = this;

            const metric = new RivalIQ.models.MetricDefinition({
                concept: RivalIQ.metrics.descriptions.SOCIAL_POSTS_POSTED_URLS.id,
                dimensions: ['observation'],
                property: 'observation',
                includeObservations: true
            });
            App.utils.updateMetric(metric, me.getProps());

            return metric.fetch()
                .then(function (results) {
                    const observations = _(results.getValue())
                        .values()
                        .map(_.last)
                        .sortBy('idx')
                        .value();
                    const columns = (observations.length ? _.chunk(observations, Math.ceil(observations.length / 2)) : []);
                    me.collection = new Backbone.Collection(_.map(columns, function (observations) {
                        return {
                            observations: observations
                        };
                    }));
                });
        },

        childViewOptions: function (childCollection) {

            const me = this;

            return {
                dashboardModel: me.dashboardModel,
                collection: new Backbone.Collection(childCollection.get('observations'))
            };
        }
    });

    const LinksSharedObservationsWidget = RivalIQ.apps.Dashboard.models.Widget.extend({
        title: function () {
            const me = this;
            const companyId = me.getProp('focusCompanyId');
            const company = RivalIQ.state.landscape.getCompanyById(companyId);
            return [company.get('name'), 'Key Insights'].join(' ');
        },
        description: RivalIQ.strings.social_post_links_shared_observations_description,
        hasFooter: _.constant(false),
        view: LinksSharedObservationsView
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.SOCIAL_POSTS_LINKS_SHARED_OBSERVATIONS, LinksSharedObservationsWidget);

});
